/* Copyright (c) 2021 Paul Nebel */

import React, { useState } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import { BUILD_ENV, CANONICAL_URL } from 'gatsby-env-variables';
import { CANONICAL_URL } from 'gatsby-env-variables';

import LogoSmall from './logo-small';
import InstallPwaNotification from './install-pwa-notification';
import CFModal from './modal';
import SettingsModal from './settings-modal';

// sw-updater-notification uses service-worker-updater which has a version incompatibility with this code
// import UpdateNotification from './sw-update-notification';

const closedModalClass = 'modal p-5';
const openModalClass = 'modal is-active is-clipped p-5';
const closedBurgerClass = 'navbar-burger';
const openBurgerClass = 'navbar-burger is-active';
const closedNavbarClass = 'navbar-menu';
const openNavbarClass = 'navbar-menu is-active';

const LogoSmallIcon = styled(LogoSmall)`
    width: 30px;
    height: 30px;
`;

function Header({ siteTitle }) {
    const [state, setState] = useState({
        betaModalClass: closedModalClass,
        settingsModalClass: closedModalClass,
        ppModalClass: closedModalClass,
        burgerClass: closedBurgerClass,
        mainNavbarClass: closedNavbarClass,
        burgerOpen: false,
    });
    const updateSettingsModalClass = (newModalClass) =>
        setState((prevState) => {
            return {
                ...prevState,
                settingsModalClass: newModalClass,
            };
        });
    const updateBetaModalClass = (newModalClass) =>
        setState((prevState) => {
            return {
                ...prevState,
                betaModalClass: newModalClass,
            };
        });
    const burgerState = !state.burgerOpen;
    return (
        <div className="container is-max-desktop">
            <nav
                className="navbar is-black"
                role="navigation"
                aria-label="main navigation"
            >
                <div className="navbar-brand ml-0">
                    <a
                        className="navbar-item is-justify-content-center pl-5 pr-5"
                        href={CANONICAL_URL}
                    >
                        <LogoSmallIcon color="#dee5ed" />
                    </a>
                    <a className="navbar-item pl-0" href={CANONICAL_URL}>
                        <span
                            style={{
                                fontSize: '30px',
                                color: '#dee5ed',
                                fontWeight: 'bold',
                            }}
                        >
                            {siteTitle}
                        </span>
                    </a>
                    <a
                        role="button"
                        className={state.burgerClass}
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="mainNavbar"
                        style={{ height: '3.75rem', width: '3.75rem' }}
                        onClick={() =>
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    burgerOpen: burgerState,
                                    burgerClass: burgerState
                                        ? openBurgerClass
                                        : closedBurgerClass,
                                    mainNavbarClass: burgerState
                                        ? openNavbarClass
                                        : closedNavbarClass,
                                };
                            })
                        }
                    >
                        <span
                            aria-hidden="true"
                            style={{ color: '#dee5ed' }}
                        ></span>
                        <span
                            aria-hidden="true"
                            style={{ color: '#dee5ed' }}
                        ></span>
                        <span
                            aria-hidden="true"
                            style={{ color: '#dee5ed' }}
                        ></span>
                    </a>
                </div>

                <div id="mainNavbar" className={state.mainNavbarClass}>
                    <div className="navbar-start">
                        <div className="navbar-item is-justify-content-center"></div>
                    </div>
                    <div className="navbar-end">
                        <div className="navbar-item">
                            <div className="buttons mr-5">
                                <button
                                    className="button is-info navbar-item is-rounded"
                                    onClick={() => {
                                        setState((prevState) => {
                                            return {
                                                ...prevState,
                                                betaModalClass: openModalClass,
                                            };
                                        });
                                        return false;
                                    }}
                                >
                                    Beta
                                </button>
                                <button
                                    className="button is-info navbar-item is-rounded"
                                    onClick={() => {
                                        setState((prevState) => {
                                            return {
                                                ...prevState,
                                                settingsModalClass:
                                                    openModalClass,
                                            };
                                        });
                                        return false;
                                    }}
                                >
                                    Settings
                                </button>
                                <InstallPwaNotification
                                    isNotification={false}
                                    name="header"
                                />
                                <button className="button is-info navbar-item is-rounded">
                                    <Link to="/privacy-policy">
                                        <span style={{ color: '#dee5ed' }}>
                                            Privacy Policy
                                        </span>
                                    </Link>
                                </button>
                                {/* { BUILD_ENV === 'production' && <UpdateNotification isNotification={ false } /> } */}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <CFModal
                modalClass={state.betaModalClass}
                handleModalClassChanged={updateBetaModalClass}
                title="What does Beta mean?"
            >
                <div>
                    <div className="block">
                        <b>Beta</b> means that this app is still under
                        development.
                    </div>
                    <div className="block">There is much more to come.</div>
                    <div className="block">
                        Visit{' '}
                        <a href={`${CANONICAL_URL}/chord-fluent/roadmap`}>
                            DogFish Music
                        </a>{' '}
                        for more information and updates.
                    </div>
                </div>
            </CFModal>
            <SettingsModal
                modalClass={state.settingsModalClass}
                handleModalClassChanged={updateSettingsModalClass}
            />
        </div>
    );
}

Header.propTypes = {
    siteTitle: PropTypes.string,
};

Header.defaultProps = {
    siteTitle: ``,
};

export default Header;
